import { Container, Reveal, RevealGroup } from '@/components/common'
import { approachSteps } from '@/constants/programmes'

export const ProgrammeApproach = () => {
  return (
    <section className="bg-ibon-dark py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.02] tracking-[-0.02em] text-white sm:text-5xl lg:text-6xl">
              From idea to <span className="text-white/40">lasting impact.</span>
            </h2>
          </Reveal>
        </div>

        <RevealGroup className="mt-16 grid gap-px overflow-hidden border border-white/10 bg-white/10 lg:grid-cols-3">
          {approachSteps.map(({ no, title, description, Icon }) => (
            <article
              key={no}
              className="group bg-ibon-dark p-8 transition-colors hover:bg-white/5 lg:p-10"
            >
              <Icon className="text-3xl text-ibon-sky" />
              <h3 className="mt-8 text-2xl font-bold tracking-tight text-white sm:text-3xl">
                {title}
              </h3>
              <p className="mt-5 text-base leading-relaxed text-white/65">{description}</p>
            </article>
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
